import { render, staticRenderFns } from "./PlayBox.vue?vue&type=template&id=6226e7ce&scoped=true&lang=pug&"
import script from "./PlayBox.vue?vue&type=script&lang=js&"
export * from "./PlayBox.vue?vue&type=script&lang=js&"
import style0 from "./PlayBox.vue?vue&type=style&index=0&id=6226e7ce&scoped=true&lang=scss&"
import style1 from "./PlayBox.vue?vue&type=style&index=1&id=6226e7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6226e7ce",
  null
  
)

export default component.exports